import { useEditor, useNode } from "@craftjs/core";
import clsx from "clsx";
import { useRef } from "react";
import ContentEditable from "react-contenteditable";

interface TagContainerProps {
    text: string;
    children?: React.ReactNode;
}

const TagContainer = ({ text, children }: TagContainerProps) => {
    const editableRef = useRef<HTMLDivElement | null>(null);

    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode();

    const {
        enabled,
        query: { node },
    } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    const isFilterEnabled = node("PAGE_CONTENT").get().data.props.filters === "yes";
    const isTocEnabled = node("PAGE_CONTENT").get().data.props.toc === "yes";
    const isAnchorsEnabled = node("PAGE_CONTENT").get().data.props.anchors === "yes";

    return (
        <div
            ref={(ref) => connect(ref!)}
            className={clsx([
                "relative w-16 h-16",
                isFilterEnabled || isAnchorsEnabled || isTocEnabled ? "col-start-2" : "",
            ])}
        >
            {children}

            <ContentEditable
                html={text || ""}
                innerRef={editableRef}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((props: any) => (props.text = e.target.value), 500);
                }}
                tagName={`span`}
                className="lead absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
            />
        </div>
    );
};

export default TagContainer;

TagContainer.craft = {
    displayName: "Tag",
    props: {
        margin: [0, 0, 0, 0],
        text: "A",
    },
};
